var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu21(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 11.3569H0.875C0.391998 11.3569 0 10.9649 0 10.4819C0 9.99893 0.391998 9.60693 0.875 9.60693H20.125C20.608 9.60693 21 9.99893 21 10.4819C21 10.9649 20.608 11.3569 20.125 11.3569Z",
    fill: "#2D3035"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 4.64844H0.875C0.391998 4.64844 0 4.25644 0 3.77344C0 3.29044 0.391998 2.89844 0.875 2.89844H20.125C20.608 2.89844 21 3.29044 21 3.77344C21 4.25644 20.608 4.64844 20.125 4.64844Z",
    fill: "#2D3035"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 18.0649H0.875C0.391998 18.0649 0 17.6729 0 17.1899C0 16.7069 0.391998 16.3149 0.875 16.3149H20.125C20.608 16.3149 21 16.7069 21 17.1899C21 17.6729 20.608 18.0649 20.125 18.0649Z",
    fill: "#2D3035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu21);
export default __webpack_public_path__ + "static/media/menu-2 1.04b014e88f2bec54200ff5beae61d986.svg";
export { ForwardRef as ReactComponent };